import React from 'react';
import styled from '@emotion/styled';
import useIntersectionObserver from 'hooks/useIntersectionObserver';

const StaggerContainer = styled.div`
  width: 100%;

  & > * {
    opacity: 0;
    transform: ${({ variant }) =>
      variant === 'fade' ? 'slide' : 'translateY(60px)'};
    transition:
      opacity 0.9s ease,
      transform 0.9s ease;
  }

  &.visible > * {
    opacity: 1;
    transform: ${({ variant }) =>
      variant === 'fade' ? 'slide' : 'translateY(0)'};
  }
`;

const AnimationWrapper = ({
  children,
  threshold = 0.3,
  root = null,
  rootMargin = '0px',
  stagger = 0.1,
  variant = 'fade',
  as = 'div',
}) => {
  const { ref, isIntersecting } = useIntersectionObserver({
    threshold,
    root,
    rootMargin,
  });

  return (
    <StaggerContainer
      ref={ref}
      className={isIntersecting ? 'visible' : ''}
      as={as}
      variant={variant}
    >
      {React.Children.map(children, (child, index) =>
        React.isValidElement(child)
          ? React.cloneElement(child, {
              style: {
                ...(child.props.style || {}),
                transitionDelay: `${index * stagger}s`,
              },
            })
          : child,
      )}
    </StaggerContainer>
  );
};

export default AnimationWrapper;
